import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DEFAULT_CONFIG = {
  commerce_enabled: false,
  freefest_date: "2026-08-01",
  freefest_location: "Philadelphia Navy Yard Marine Parade Grounds, S Broad St, Philadelphia, PA 19112",
};

export async function fetchConfig() {
  try {
    const r = await axios.get(`${API}/config`, { timeout: 5000 });
    return { ...DEFAULT_CONFIG, ...r.data };
  } catch {
    return DEFAULT_CONFIG;
  }
}

// Section order — nav routes/anchors only.
// Items with a `path` open a route (React Router). Items without `path`
// are in-page smooth-scroll anchors on the homepage; when clicked from a
// non-home route, we navigate home first then scroll to the anchor.
export const SECTIONS = [
  { id: "merch",      label: "Shop" },
  { id: "categories", label: "Categories" },
  { id: "tour",       label: "Upcoming Dates" },
  { id: "archives",   label: "The Archives",   path: "/album" },
  { id: "new-music",  label: "New Music",      path: "/new-music" },
  { id: "book",       label: "Book Freeway",   path: "/book-freeway" },
  { id: "news",       label: "News",           path: "/news" },
];

export const SOCIALS = {
  instagram: {
    url: "https://www.instagram.com/phillyfreeway/",
    label: "Philadelphia Freeway on Instagram",
  },
  youtube: {
    url: "https://www.youtube.com/@freewayfta",
    label: "Freeway FTA on YouTube",
  },
};
